import { API_ENDPOINTS } from '@/constants/api';
import { api } from '@/shared/api';
import { BaseApi } from '@/shared/api/baseApi';
import { ENTITY_CONFIGS } from '@/shared/constants/entities';
import type { Banner, BannerFormData, BannerLocationsResponse } from '../types';

const bannersApiInstance = new BaseApi<Banner, BannerFormData>(ENTITY_CONFIGS.banners.endpoints);

export const bannersApi = {
  getList: bannersApiInstance.getList.bind(bannersApiInstance),
  getOne: bannersApiInstance.getOne.bind(bannersApiInstance),
  create: bannersApiInstance.create.bind(bannersApiInstance),
  update: bannersApiInstance.update.bind(bannersApiInstance),
  delete: bannersApiInstance.delete.bind(bannersApiInstance),
  getLocations: async (): Promise<BannerLocationsResponse> => {
    const response = await api.get<BannerLocationsResponse>(API_ENDPOINTS.BANNERS.LOCATIONS);
    return response.data;
  },
};
